import { gql } from 'apollo-boost';


export const AGREEMENTS_QUERY = gql`
query agreements($personId: UUID) {
    agreements(personID: $personId) {
      edges {
        node {
          id
          personId
          agreeToTerm
          termId
        }
      }
    }
  }
`;